import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../constants/url";
import styled from "styled-components";
import { jwtDecode } from "jwt-decode";
import { api } from "../constants/api";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  flex-direction: column;
  gap: 1rem;
`;

const Loader = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const Message = styled.div`
  font-size: 1.2rem;
  color: #333;
`;

const Payment = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // const getMemberInfo = async (id) => {
  //   try {
  //     let localuser = JSON.parse(localStorage.getItem('localuser') || '{}')
  //     const res = await api(true, `/admin/get-all-members`, 'get', {}, { authorization: `Bearer ${localuser.token}` })
  //     const data = res?.data?.data?.result;
  
  //     const address = data?.find((item) => item.memberCode.toString() === id)?.address || "";
  
  //     // Format here
  //     const formattedAddress = address.replace(/(\r\n|\n|\r)/gm, " ");
  
  //     return formattedAddress;
  //   } catch (error) {
  //     console.log(error, ' <== Error while fetching member info', error);
  //   } finally {
  //   }
  // }

  useEffect(() => {
    const validateAndInitiatePayment = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const userToken = params.get("userToken");
        const amount = params.get("amount");
        const orderId = params.get("order_id");
        const memberCode = params.get("memberCode");
        const memberId = params.get("memberId");
        const userData = jwtDecode(userToken);
        // const address = await getMemberInfo(memberCode.split('-')[1]);

        if (!userToken || !amount || !orderId) {
          throw new Error("Missing required parameters");
        }
        
        const payload = new URLSearchParams();
        payload.append('amount', parseFloat(amount).toFixed(2).toString());
        payload.append('order_id', orderId);
        payload.append('currency', 'INR');
        payload.append('merchant_id', "4184792");
        payload.append('language', 'EN');
        payload.append('upiPaymentFlag', '');
        payload.append('redirect_url', `https://app.summairsportsclub.org/api/ccavResponseHandler?userToken=${userToken}&order_id=${orderId}&memberCode=${memberCode}&memberId=${memberId}`);
        payload.append('cancel_url', `https://app.summairsportsclub.org/api/ccavResponseHandler?userToken=${userToken}&order_id=${orderId}&memberCode=${memberCode}&memberId=${memberId}`);

        // Uncommnet when want to work on local
        // payload.append('redirect_url', `http://192.168.1.31:7000/api/ccavResponseHandler?userToken=${userToken}&order_id=${orderId}&memberCode=${memberCode}&memberId=${memberId}`);
        // payload.append('cancel_url', `http://192.168.1.31:7000/api/ccavResponseHandler?userToken=${userToken}&order_id=${orderId}&memberCode=${memberCode}&memberId=${memberId}`);
        payload.append("billing_name", userData.FullName);
        // payload.append("billing_address", address);
        payload.append("billing_city", "Jamnagar");
        payload.append("billing_name", userData.FullName);
        payload.append("billing_state", "Gujarat");
        // payload.append("billing_zip", "361005");
        payload.append("billing_country", "India");
        payload.append("billing_tel", userData.MobileNo);
        payload.append("billing_email", userData.Email);
        const response = await axios.post(
          `${baseUrl}/ccavRequestHandler`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
              memberId,
              memberCode,
              'Content-Type': 'multipart/form-data',
              Accept: 'text/html',
            },
            responseType: 'text',
          }
        );

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = response.data;
        const form = tempDiv.querySelector("form");
        if (form) {
          form.setAttribute("target", "_self");
          document.body.appendChild(form);
          form.submit();
        } else {
          throw new Error("No form found in response");
        }

        setLoading(false);
      } catch (err) {
        console.error("Payment error:", err);
        setError(err);
        setLoading(false);
      }
    };

    validateAndInitiatePayment();
  }, [location]);

  if (loading) {
    return (
      <Container>
        <Loader />
        <Message>Loading...</Message>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Message style={{ color: "red" }}>Error: {error}</Message>
      </Container>
    );
  }

  return (
    <Container>
      <Loader />
      <Message>Redirecting to payment gateway...</Message>
    </Container>
  );
};

export default Payment;
